export const activated_features = [
  'only_title_quickcart',
  'recommended_products_as_slider_in_checkout',
  'paypal_quickcart',
]
